import { Navigate } from "react-router";

export default function RootRedirect() {
  const returnTo = sessionStorage.getItem("returnTo");

  if (returnTo && returnTo.startsWith("/") && !returnTo.startsWith("/auth")) {
    sessionStorage.removeItem("returnTo");
    return <Navigate to={returnTo} replace />;
  }

  return <Navigate to="/home" replace />;
}

